import { Link, useLocation } from 'react-router';
import OpportunityItem from '../OpportunityItem';

export default function CardViewOpportunities({ opportunities }: { opportunities: any }) {
  const location = useLocation();
  return (
    <div>
      <section className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5'>
        {opportunities.map((p: any) => (
          <Link key={p.opportunityInfo.ID} to={`${location.pathname}/${p.opportunityInfo.docId}`}>
            <OpportunityItem key={p.opportunityInfo.ID} opportunity={p} />
          </Link>
        ))}
      </section>
    </div>
  );
}
